// components/Layout.js
import { useState } from "react";
import MobileFooter from "./MobileFooter";
import MobileSidebar from "./MobileSidebar";
import { Menu } from "lucide-react";

const Layout = ({ children }) => {
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  return (
    <div style={styles.container}>

      {/* Top Header */}
      <div style={styles.header}>
        <Menu onClick={() => setOpen(true)} />
        <img src="../assets/img/Logo.png" alt="ParkingPal Logo" style={{ height: '32px' }} />
      </div>

      {/* Content */}
      <div style={styles.content}>{children}</div>

      {/* Footer */}
      <MobileFooter />

      {/* Sidebar */}
      <MobileSidebar
        open={open}
        onClose={() => setOpen(false)}
        onLogout={handleLogout}
      />

    </div>
  );
};

const styles = {
  container: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: "60px",
    background: "#fff",
    color: "#33AE54",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "0 15px",
    zIndex: 1000,
  },
  content: {
    padding: "10px",
  },
};

export default Layout;